import declare from "dojo/_base/declare";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";

const _StyleAndColorwayMixin = declare(null, {
	/**
	 * @override
	 * Ignore invalid entries
	 */
	getStoreOptions(ctx: Context, h: Heading): Record<string, any> {
		return { ignoreInvalid: true };
	},
});

export = _StyleAndColorwayMixin;